export default __webpack_public_path__ + "static/media/Preloader.8c15fc34.svg";